(function($) {
    $(document).ready(function() {


        var imgBox = $('.section1-imgbox');
        var heightRight = $('.section1-right').height();

        imgBox.height(heightRight);

        // ScrollTop


        var topWindow = $('#toTop');

        $(window).scroll(function() {

            var px = $(this).scrollTop();



            if ($(this).scrollTop() > 500) {

                topWindow.fadeIn(500);

            } 

            else { 

                topWindow.fadeOut(500);

            }

        });



        // click on bottom arrow icon, the page scroll to top

        topWindow.click(function(){

            $('html, body').animate({scrollTop:0}, 'slow');

        });


        // anilated anchor in homapage header

        $('.js-scrollTo').on('click', function(event) {

            console.log('ok');

            event.preventDefault();

            var page = $(this).attr('href');

            var speed = 500;

            $('html, body').animate({scrollTop: $(page).offset().top}, speed);

        });


        //Fixing top bar

        $(window).scroll(function(){

            if ($(this).scrollTop() > 800) {

                $('.top-bar').addClass('fixed');
                $('#masthead.sidebar-menu').addClass('fixed');

            }else{

                $('.top-bar').removeClass('fixed');
                $('#masthead.sidebar-menu').removeClass('fixed');
            }

        });

        // burger animation and display menu portable size

        var menuToggle  = $('.btn-menu');

        var header      = $('.sidebar-menu');

        var body        = $('body');

        menuToggle.click(function() {

            console.log('OK');

            body.toggleClass('menu-open');

            header.toggleClass('menu-open');

        });

        $(window).resize(function() {
            var widthWindow = $(this).width();
            if(widthWindow > 992) {
                header.removeClass('menu-open');
                body.removeClass('menu-open');
            }
        });


        // prevent default search bar behaviour when the input field is empty

        $('.search-form').on('submit', function(e){

            var val =  $('.search-field').val();

            if(val === ""){
                e.preventDefault();
            }

        });


        // Show mini cart on hover

        $('.panier-link').mouseenter(function(){

            $('.mini-cart').slideDown();
            
        });

        // Hide mini cart and the flash message when clicking on closing icon

        $('body').on('click', '.close-cart', function(){

            $('.mini-cart').slideUp();
            $('.flash-message').hide();

        });


        $('.flash-message').hide();

        var qtyCurrent = $(".cart_qty_choice");
            var cartItem = $('.cart-icon .items');
            var miniItem = $("#items_count");
            
            $(document,".qty_choice .less").on('click', ".qty_choice .less", function() {
                var qty = $(this).parents('.product-quantity').children('.quantity').children('.qty');
                var qtyValue = qty.val();
                
                if(qtyValue >= 1) {
                    var newQty = Number(qtyValue) - 1;
                    qty.val(newQty).change();
                    $("button[name='update_cart']").click();
                    qtyCurrent.text(newQty);
                };
            });
            $(document,".qty_choice .more").on('click', ".qty_choice .more", function() {
                var qty = $(this).parents('.product-quantity').children('.quantity').children('.qty');
                var qtyValue = qty.val();
                
                if(qtyValue >= 0) {
                    var newQty = Number(qtyValue) + 1;
                    qty.val(newQty).change();
                    $("button[name='update_cart']").click();
                    qtyCurrent.text(newQty);
                };
            });

            // RGPD to check
            $("#to_check,.terms label.checkbox").on('click', function() {
                var checkBox = $("#rgpd");
                checkBox.trigger('click');
                $('#to_check').toggleClass('check');
                $("#billing_email").trigger('change');
            });

            
            // $("#to_shipping,#ship-to-different-address label.checkbox").on('click', function() {
            //     var checkBoxShipping = $("#ship-to-different-address-checkbox");
            //     checkBoxShipping.trigger('click');
            //     $('#to_shipping').toggleClass('check');
            // });

            // shipping address to check
            $("#to_shipping").on('click', function() {
                var checkBoxShipping = $("#ship-to-different-address-checkbox");
                checkBoxShipping.trigger('click');
                if(checkBoxShipping.is(':checked')) {
                    $('#to_shipping').addClass('check');
                }
                else {
                    $('#to_shipping').removeClass('check');
                }
            });
            
            $("#ship-to-different-address label.checkbox").on('change', function() {
                $('#to_shipping').toggleClass('check');
            });

            // payment method registered to check
            $(document).on('click', ".woocommerce-SavedPaymentMethods li label", function() {
                $(".woocommerce-SavedPaymentMethods li label").removeClass('check');
                $(this).addClass('check');
            });

            // new payment method to check
            $(document).on('click', ".woocommerce-SavedPaymentMethods-saveNew label", function() {
                $(".woocommerce-SavedPaymentMethods-saveNew label").toggleClass('check');
            });

            // to close france pop-up in checkout page 
            if($(".only_france").length) {
                $("body").addClass('france_open');
                $(window).on('beforeunload', function() {
                    $(window).scrollTop(0); 
                });
            }
            $(".france_btn").on('click', function() {
                $(".only_france").fadeOut();
                $("body").removeClass('france_open');
            });

    });

})(jQuery);




